module.exports = __webpack_public_path__ + "static/media/22_plantilla_combo_rectangular_marco_comida_36.bc5e2cba.png";